// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.942Z

import {
    GetUserApiResponse,
    GetUserApiArg,
    GetUserCurrentApiResponse,
    GetUserCurrentApiArg,
    PutUserCurrentApiResponse,
    PutUserCurrentApiArg,
    GetUserByUserIdApiResponse,
    GetUserByUserIdApiArg,
    PutUserByUserIdApiResponse,
    PutUserByUserIdApiArg
} from "~/api/userAPI.types";

import { baseAPI as api } from "~/api/baseAPI";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getUser: build.query<GetUserApiResponse, GetUserApiArg>({
            query: (queryArg) => ({
                url: "/user",
                params: {
                    status: queryArg.status,
                    pagination: queryArg.pagination,
                    sort: queryArg.sort,
                },
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        getUserCurrent: build.query<
            GetUserCurrentApiResponse,
            GetUserCurrentApiArg
        >({
            query: () => ({ url: "/user/current" }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        putUserCurrent: build.mutation<
            PutUserCurrentApiResponse,
            PutUserCurrentApiArg
        >({
            query: (queryArg) => ({
                url: "/user/current",
                method: "PUT",
                body: queryArg,
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        getUserByUserId: build.query<
            GetUserByUserIdApiResponse,
            GetUserByUserIdApiArg
        >({
            query: (queryArg) => ({ url: `/user/${queryArg}` }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        putUserByUserId: build.mutation<
            PutUserByUserIdApiResponse,
            PutUserByUserIdApiArg
        >({
            query: (queryArg) => ({
                url: `/user/${queryArg["user-id"]}`,
                method: "PUT",
                body: queryArg.userPutUserProfileRequest,
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as userAPI };
export const {
    useGetUserQuery,
    useLazyGetUserQuery,
    useGetUserCurrentQuery,
    useLazyGetUserCurrentQuery,
    usePutUserCurrentMutation,
    useGetUserByUserIdQuery,
    useLazyGetUserByUserIdQuery,
    usePutUserByUserIdMutation,
} = injectedRtkApi;
